import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/revision/${string}/modal`;

export const ROUTE: RouteDefinition = `${baseRoute}/revision/:workOrderRevisionId/modal`;

export const URL = (workOrderRevisionId: number): RouteDefinition => `${baseRoute}/revision/${workOrderRevisionId}/modal`;
